import { z } from 'zod';

export const SignalAuditActionSchema = z.enum([
  'CREATED',
  'LABEL_CHANGED',
  'STAGE_CHANGED',
  'STATUS_CHANGED',
  'RANK_CHANGED',
  'CATEGORY_CHANGED',
  'ASSIGNED',
  'ENRICHED',
  'ARCHIVED',
  'RESTORED',
]);

export const SignalAuditLogSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  signalId: z.string(),
  action: SignalAuditActionSchema,
  fieldName: z.string().nullable(),
  oldValue: z.string().nullable(),
  newValue: z.string().nullable(),
  actorType: z.enum(['USER', 'SYSTEM', 'INTEGRATION', 'AI']),
  actorId: z.string().nullable(),
  actorName: z.string().nullable(),
  note: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()).nullable(),
  createdAt: z.string(),
});

export const SignalAuditLogsResponseSchema = z.object({
  logs: z.array(SignalAuditLogSchema),
  total: z.number(),
});

export type SignalAuditAction = z.infer<typeof SignalAuditActionSchema>;
export type SignalAuditLog = z.infer<typeof SignalAuditLogSchema>;
export type SignalAuditLogsResponse = z.infer<
  typeof SignalAuditLogsResponseSchema
>;
